var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "error" } }, [
    _c("section", { staticStyle: { padding: "10px" } }, [
      _c("p", [
        _vm._v(
          "\n      " +
            _vm._s(_vm.$t("message.pleasetrytologinlater")) +
            "\n      "
        ),
        _c(
          "a",
          {
            attrs: { href: "javascript: void(0)" },
            on: {
              click: function($event) {
                return _vm.$store.dispatch("Logout")
              }
            }
          },
          [_vm._v("Login")]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-74cae0c1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74cae0c1","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/error/Error.vue
// module id = null
// module chunks = 